import {
  dienstanTestimonials,
  IDienstanTestimonial
} from '@/pages/home/components/diensten/dienstan.data.tsx';
import { Carousel } from '@inexture/carousel';
import sliderCss from './slider.module.css';
import { FC } from 'react';

const Testimonial: FC<{ data: IDienstanTestimonial }> = ({ data }) => {
  const isRight = data.position === 'right';
  return (
    <div
      className={`flex justify-between gap-10 ${isRight ? 'flex-row-reverse' : ''}`}
    >
      <figure className="max-w-[180px] h-[210px] w-full text-center">
        <span
          className="img-mask"
          style={{ ...(isRight ? { right: 0 } : { left: 0 }) }}
        />
        <img src={data.logo} alt={data.name} />
      </figure>
      <div className="w-[calc(100%-180px)]">
        <h4 className="font-semibold text-md">{data.name}</h4>
        <p className="italic text-sm">{data.company}</p>
        <blockquote className="my-4 italic">{data.comment}</blockquote>
      </div>
    </div>
  );
};

const DienstenTestimonial = () => {
  return (
    <div className="py-10">
      <Carousel
        h={260}
        withControls={false}
        withIndicators
        controlSize={20}
        classNames={sliderCss}
      >
        {dienstanTestimonials.map((testimonial, index) => {
          return (
            <Carousel.Slide key={index}>
              <Testimonial data={testimonial} />
            </Carousel.Slide>
          );
        })}
      </Carousel>
    </div>
  );
};

export default DienstenTestimonial;
